import { type FunctionComponent } from 'react';
import { type ProductBrandFieldsFragment } from '../../../__generated__/graphql-client-types';
import { BRANDS_LINK } from '../../../constants/links';
import { type RelatedCategory } from '../../../types/product.types';
import { StyledLink } from '../../common-components/link/styled-link.component';

export type RelatedCategoriesListProps = {
	brand: ProductBrandFieldsFragment;
	categories: RelatedCategory[];
};
export const RelatedCategoriesList: FunctionComponent<RelatedCategoriesListProps> = ({ brand, categories }) => {
	const listClass = 'mb-2';
	return (
		<section>
			<strong>Related {brand.name} Links</strong>
			<ul>
				<li className={listClass}>
					<StyledLink url={BRANDS_LINK}>Browse by Brand</StyledLink>
				</li>

				{categories.map((category) => (
					<li key={category.id} className={listClass}>
						<StyledLink url={category.url}>{category.name}</StyledLink>
					</li>
				))}
			</ul>
		</section>
	);
};
